module.exports = __webpack_public_path__ + "static/media/ketoemagtramina-logo.b4588cb5.png";